<template>
  <el-row>
    <h1>Contact</h1>
    <el-card>
      follow with us on:
      <a target="blank" href="https://twitter.com/appform_llc"
        >Twitter @appform_llc</a
      >
    </el-card>
  </el-row>
</template>
<script>
export default {
  mixins: []
};
</script>
